import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import ThumbUpIcon from 'mdi-react/ThumbUpIcon';
import PriceNotice from '../components/price-notice';
import StockStatusColumnComponent from '../components/stock-status-column';
import CampaignBadgeComponent from '../../campaign-badge';
import { Truncated } from '../../truncated';

const stockIconWidth = '40px';

export const BaseProductName = styled(Truncated)`
  max-height: 3em;
  line-height: 1.5em;
`;

export const TransparencyShopInfo = styled.div`
  text-align: left;
  margin: 0;
`;

export const ProductName = styled(BaseProductName)`
  ${media.mediumDown`
    display: none;  
  `}
`;

export const ProductNameColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecommendedRetailer = styled.div`
  ${media.mediumDown`
    display: none;  
  `}

  font-size: 0.8rem;
  white-space: nowrap;
  align-self: normal;
  margin-top: 0.3rem;
  color: ${props => props.theme.text.secondary};
  ${media.smallOnly`
    display: none;
  `};
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${p => p.theme.icons.secondary};
  margin-right: 0.3rem;
`;

export const PriceAndStockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  ${media.smallOnly`
    display: grid;
    grid-template-columns: ${stockIconWidth} 1fr;
    align-items: baseline;
    
  `}
`;

export const PriceNoticeLabel = styled(PriceNotice)`
  font-size: ${layout.measurements.fontSizeSmall};
  white-space: nowrap;
  font-style: italic;
  margin-bottom: 2px;
`;

const sharedPriceColumnStyles = css`
  display: flex;
  width: auto;
  height: auto;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceColumnWrapper = styled.div`
  ${sharedPriceColumnStyles};
`;

export const PriceColumnWrapperExperiment = styled.div`
  ${sharedPriceColumnStyles};

  ${media.mediumUp`
    display: none;
  `}
`;

export const StockStatusColumn = styled(StockStatusColumnComponent)(
  props => css`
    display: flex;
    align-items: center;
  `
);

export const CampaignBadge = styled(CampaignBadgeComponent)`
  margin-bottom: 2px;
`;
